import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@services/auth.service';
import { FswService } from '@services/fsw.service';


@Component({
  selector: 'app-fsw-dashboard',
  templateUrl: './fsw-dashboard.component.html',
  styleUrls: ['./fsw-dashboard.component.scss']
})
export class FswDashboardComponent implements OnInit {
  userRecord: any[] | undefined;
  userRecordCount!: any;
  public isCollapsed = false;
  metrics!: any[];
  awpRecord: any[] | undefined;
  awpRecordCount!: any;
  trainingRecord: any[] | undefined;
  trainingRecordCount!: any;
  testingRecord: any[] | undefined;
  testingRecordCount!: any;
  userName: any;

  constructor(private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService) {
    //Testing Start
    this.spinnerService.show();
      this.userName = this.authService.getUserName();
      this.fswService.getSampleListByUser(this.userName)
        .subscribe(res => {
          debugger
          this.testingRecord = res;
          this.testingRecordCount = this.testingRecord.length;

          //Testing End
          //Training Start
          this.fswService.getTrainingListByUser(this.userName)
            .subscribe(res => {
              debugger
              this.trainingRecord = res;
              this.trainingRecordCount = this.trainingRecord.length;
              //Training End
              //AWP Start
              this.fswService.getAwsListByUser(this.userName)
                .subscribe(res => {
                  debugger
                  this.awpRecord = res;
                  this.awpRecordCount = this.awpRecord.length;
                  this.spinnerService.hide();
                  //AWP End
                  // Metrics Variables
                  this.metrics = [
                    {
                      title: 'Total Testing Done',
                      value: this.testingRecordCount,
                      color: 'color-4',
                      icon: 'far fa-eye',
                      variation: 0.03,
                      backgroundColor: 'rgb(255 168 0)'
                    },
                    {
                      title: 'Total Trainigs Completed',
                      value: this.trainingRecordCount,
                      color: 'text-info',
                      icon: 'fas fa-mouse-pointer',
                      variation: 3.78,
                      backgroundColor: 'rgb(148 0 255 / 58%)'
                    },
                    {
                      title: 'Total Awareness Programs Conducted',
                      value: this.awpRecordCount,
                      color: 'text-success',
                      icon: 'fas fa-magnet fa-rotate-90',
                      variation: -2.01,
                      backgroundColor: '#dc3545'
                    },
                    // {
                    //   title: 'Posts',
                    //   value: '147',
                    //   color: 'color-3',
                    //   icon: 'fas fa-camera',
                    //   variation: 1.02
                    // }
                  ];
                })
            })
        })
    //this.fswService.getTrainingList(this.userName)
    // .subscribe(res => {
    // debugger
    //    this.trainings = res;

    // })
  }



  panels = [
    { title: 'Recently subscribers', id: 'recently-subscribers-panel' },
    { title: 'Twitter trends', id: 'twitter-trends-panel' },
    { title: 'Most viewed youtube videos', id: 'most-viewed-yt-videos-panel' },
    { title: 'Facebook audience growth', id: 'fb-audience-growth-panel' }
  ];

  // Monthly Subscribers Variables
  lineChart = {
    type: 'line',
    options: {
      responsive: true,
      title: {
        display: false,
        text: 'Monthly subscribers'
      },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [
          {
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Month'
            }
          }
        ],
        yAxes: [
          {
            display: true,
            scaleLabel: {
              display: false,
              labelString: 'Value'
            }
          }
        ]
      }
    },
    data: {
      labels: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19'
      ],
      datasets: [
        {
          label: 'facebook',
          data: [
            19,
            52,
            58,
            45,
            18,
            12,
            85,
            93,
            64,
            82,
            37,
            36,
            24,
            35,
            103,
            53,
            81,
            50,
            48
          ],
          fill: false,
          pointRadius: 1,
          pointHoverRadius: 5,
          borderDash: [5, 5]
        },
        {
          label: 'twitter',
          data: [
            10,
            5,
            9,
            38,
            99,
            72,
            79,
            64,
            88,
            53,
            25,
            5,
            51,
            28,
            46,
            11,
            56,
            74,
            88
          ],
          fill: false,
          pointRadius: 1,
          pointHoverRadius: 5
        },
        {
          label: 'youtube',
          data: [
            84,
            96,
            63,
            59,
            83,
            32,
            72,
            7,
            89,
            42,
            70,
            19,
            71,
            96,
            36,
            68,
            14,
            82,
            40
          ],
          fill: false,
          pointRadius: 1,
          pointHoverRadius: 5
        }
      ]
    }
  };

  lineChartColors: Array<any> = [
    {
      // facebook
      backgroundColor: 'rgb(59,89,152)',
      borderColor: 'rgb(59,89,152)'
    },
    {
      // twitter
      backgroundColor: 'rgb(0,172,237)',
      borderColor: 'rgb(0,172,237)'
    },
    {
      // youtube
      backgroundColor: 'rgb(250,0,0)',
      borderColor: 'rgb(250,0,0)'
    }
  ];

  // Recently Subscribers Variables
  recentlySubscribers = [
    {
      user: 'axelle guillot',
      picture: 'https://randomuser.me/api/portraits/thumb/women/94.jpg',
      email: 'axelle.guillot@example.com',
      network: 'facebook',
      date: '1 hours ago'
    },
    {
      user: 'josep garcia',
      picture: 'https://randomuser.me/api/portraits/thumb/men/3.jpg',
      email: 'josep.garcia@example.com',
      network: 'twitter',
      date: '9 mins ago'
    },
    {
      user: 'lemuel campos',
      picture: 'https://randomuser.me/api/portraits/thumb/men/76.jpg',
      email: 'lemuel.campos@example.com',
      network: 'youtube',
      date: '8 mins ago'
    },
    {
      user: 'carolyn stone',
      picture: 'https://randomuser.me/api/portraits/thumb/women/62.jpg',
      email: 'carolyn.stone@example.com',
      network: 'youtube',
      date: '16 hours ago'
    }
  ];

  // Used for dropdown options
  subscriptionOptions: string[] = ['This month', 'Last month', 'This year'];
  selectedSubscription: string = this.subscriptionOptions[0];



  ngOnInit() { }

  // Accordion Events
  changeSubscriptionOption(subscriptionOption: string) {
    this.selectedSubscription = subscriptionOption;
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

}
